import { BreakPoint } from '../../../../hooks/useBreakPoint/consts';
import { BreakpointAspectRatioConfigs } from '../../LegacyPicture/image-transformer/types';

export enum ImageBottomPosition {
  Left = 'left',
  Right = 'right',
}

export const breakpointAspectRatioConfigs: BreakpointAspectRatioConfigs = [
  {
    breakpoint: BreakPoint.XSS,
    aspectRatio: '16:10',
    width: 320,
  },
];
